import { AgencySchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { agenciesKeys } from './keys';

export function useAgency(agencyId: string | undefined) {
  return useQuery({
    queryKey: agenciesKeys.item(agencyId ?? ''),
    queryFn: async () => {
      const res = await apiClient.get<ApiResponse<AgencySchema>>(
        `/v1/agencies/${agencyId}`,
        undefined
      );
      return res.data;
    },
    enabled: !!agencyId,
  });
}
